import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // 1. Import useNavigate
import BoxButton from "./BoxButton";
import "./Box.css";
import "./BoxApplication.css";

const BoxApplication = ({ inquiry }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate(); // 2. Initialize navigate

  const isNewApplication = () => {
    if (!inquiry.submitted_at) return false;
    const submittedTime = new Date(inquiry.submitted_at).getTime();
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000;
    return now - submittedTime < oneDay;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-CA");
  };

  // 3. Create the handler function
  const handleSearchOnMap = () => {
    const fullAddress = `${inquiry.address || ""}, ${inquiry.city || ""}, ${inquiry.province || ""}`;
    if (fullAddress.length > 5) { // Basic check for a valid address
      // Navigate to the correct top-level /Employees route
      navigate(`/Employees?searchAddress=${encodeURIComponent(fullAddress)}`);
    } else {
      alert("No address available for this applicant.");
    }
  };

  return (
    <div className={`box-card ${isNewApplication() ? "new-inquiry" : ""}`}>
      <h4>{inquiry.first_name} {inquiry.last_name}</h4>

      <div>
        <strong>Email:</strong> {inquiry.email || "N/A"}
      </div>
      <div>
        <strong>Phone:</strong> {inquiry.phone || "N/A"}
      </div>
      <div>
        <strong>City:</strong> {inquiry.city || "N/A"}
      </div>

      {isExpanded && (
        <>
          <div>
            <strong>Address:</strong> {`${inquiry.address || ""}, ${inquiry.province || ""}`}
            {/* 4. Add the search button */}
            {inquiry.address && (
              <button onClick={handleSearchOnMap} className="map-search-link-btn">
                Search on Map
              </button>
            )}
          </div>
          <div><strong>Date of Birth:</strong> {formatDate(inquiry.dob)}</div>
          <hr className="box-divider" />
          <div><strong>Experience Level:</strong> {inquiry.experience_level || "N/A"}</div>
          <div><strong>Criminal Record:</strong> {inquiry.criminal_record == null ? 'N/A' : inquiry.criminal_record ? 'Yes' : 'No'}</div>
          <div><strong>Veteran:</strong> {inquiry.veteran_status == null ? 'N/A' : inquiry.veteran_status ? 'Yes' : 'No'}</div>
          <div><strong>Has Vehicle:</strong> {inquiry.has_vehicle == null ? 'N/A' : inquiry.has_vehicle ? 'Yes' : 'No'}</div>
          <div><strong>Has Black Suit:</strong> {inquiry.has_black_suit == null ? 'N/A' : inquiry.has_black_suit ? 'Yes' : 'No'}</div>
          <div><strong>Height (cm):</strong> {inquiry.height || "N/A"}</div>
          <div><strong>Weight (kg):</strong> {inquiry.weight || "N/A"}</div>
          <hr className="box-divider" />
          <div><strong>Notes:</strong> {inquiry.notes || "None"}</div>
          <hr className="box-divider" />
          <div>
            <strong>Resume:</strong>
            {inquiry.resume_url ? (
              <a href={inquiry.resume_url} target="_blank" rel="noopener noreferrer" className="boxapp-resume-link">
                View Resume
              </a>
            ) : (" N/A")}
          </div>
          <div>
            <strong>License:</strong>
            {inquiry.license_url ? (
              <a href={inquiry.license_url} target="_blank" rel="noopener noreferrer" className="boxapp-resume-link">
                View License
              </a>
            ) : (" N/A")}
          </div>
          <div>
            <strong>Certification:</strong>
            {inquiry.cert_url ? (
              <a href={inquiry.cert_url} target="_blank" rel="noopener noreferrer" className="boxapp-resume-link">
                View Certification
              </a>
            ) : (" N/A")}
          </div>
          <hr className="box-divider" />
          <div><strong>Consent:</strong> {inquiry.consent ? "Yes" : "No"}</div>
          <div>
            <strong>Submitted:</strong>{" "}
            {inquiry.submitted_at
              ? new Date(inquiry.submitted_at).toLocaleString()
              : "Unknown"}
          </div>
        </>
      )}

      <div className="box-buttons">
        <BoxButton type="expand" expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
      </div>
    </div>
  );
};

export default BoxApplication;

